import {stringToColor} from '@ark/react';
import {Avatar as MuiAvatar} from '@mui/material';
import Avatar from 'boring-avatars';

type MemberAvatarProps = {
  displayPicture: string | undefined;
  name: string;
  size?: number;
};

export const MemberAvatar = ({
  displayPicture,
  name,
  size = 32,
}: MemberAvatarProps) => {
  const colors = ['#e8dff5', '#fce1e4', '#fcf4dd', '#ddedea', '#daeaf6'];
  const boringAvatar = (
    <Avatar name={name} size={size} colors={colors} variant="beam" />
  );
  if (!displayPicture) return boringAvatar;
  else {
    return (
      <MuiAvatar
        src={`${import.meta.env.VITE_IMAGE_PREFIX || ''}${displayPicture}`}
        sx={{
          width: size,
          height: size,
          backgroundColor: stringToColor(name || ''),
          fontSize: size / 2.5,
        }}
      >
        {name.charAt(0)}
      </MuiAvatar>
    );
  }
};
